import WMSCapabilities from 'ol/format/WMSCapabilities';
import { GEOSERVER_API } from 'configs/endpoints';
import { connectionTimeout } from 'configs/initialValues';
import { WMSCapabilities as WMSCapabilitiesType } from 'utils/types/WMSCapabilities.interface';
import { createLogger } from 'services/debugLogger';
import EnhancedImageService, { enhancedImageService } from '../enhancedImageService';
import { RequestPriority } from '../requestQueue';

const logger = createLogger('outboundsRequest');

interface getFeatureInfoAndElevationAndCoordinatesParams {
  src: string,
  elevation: number,
  coordinates: number[]
  index: number
}

/**
 * Enhanced function to get images with queue management and priorities
 * @param src Image URL
 * @param options Additional options (priority, if real-time, etc.)
 */
export const getImage = (
  src: string,
  options: {
    isRealTime?: boolean;
    isPreload?: boolean;
    priority?: RequestPriority;
  } = {},
) => enhancedImageService.getImage(src, options);

export const getFeatureInfo = (src: string)
: Promise<{value: number, unit: string}[]> => EnhancedImageService.getFeatureInfo(src);

export const getFeatureInfoAndElevationAndCoordinates = (
  params: getFeatureInfoAndElevationAndCoordinatesParams,
) => EnhancedImageService.getFeatureInfoAndElevationAndCoordinates(params);

export const getCapabilities = async () => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), connectionTimeout);

  return fetch(`${GEOSERVER_API}/wms?service=WMS&version=1.3.0&request=GetCapabilities`, {
    signal: controller.signal,
  })
    .then(async (res) => {
      clearTimeout(timeoutId);
      if (res) {
        const parser = new WMSCapabilities();
        parser.version = '1.3.0';
        const text = await res.text();
        return JSON.parse(JSON.stringify(parser.read(text))) as Promise<WMSCapabilitiesType>;
      }
      return undefined;
    }).catch((e) => {
      clearTimeout(timeoutId);
      logger.error('WMS capabilities request failed', e);
      throw e;
    });
};
